export const INITIAL_TAB_INDEX = 0;
